import state from './ecopledges.state'
import mutations from './ecopledges.mutations'
import actions from './ecopledges.actions'
import getters from './ecopledges.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
